// Sprint 11 A2: Briefing Priorities — clickable, ranked by revenue impact

interface BriefingPriority {
  rank: number;
  type: string;
  entityId: string;
  title: string;
  description: string;
  revenueImpactCents: number;
  suggestedAction: string;
  actionUrl: string;
}

const TYPE_ICONS: Record<string, string> = {
  deal: "💰", task: "📋", lead: "🆕", alert: "🚨", booking: "📅",
};

export function BriefingPriorities({ priorities }: { priorities: BriefingPriority[] }) {
  if (priorities.length === 0) {
    return (
      <div className="border border-dashed border-[var(--color-border)] rounded-lg p-6 text-center text-[var(--color-muted-foreground)] text-sm">
        No priorities today — you're caught up
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-sm font-bold text-[var(--color-muted-foreground)] uppercase tracking-wide mb-3">Today's Priorities</h2>
      <div className="space-y-3">
        {priorities.map((p) => (
          <a
            key={p.entityId}
            href={p.actionUrl}
            className="block border border-[var(--color-border)] rounded-lg px-4 py-3 hover:shadow-md transition-shadow hover:border-[var(--color-primary)]/30"
          >
            <div className="flex items-start gap-3">
              <span className="text-lg mt-0.5">{TYPE_ICONS[p.type] ?? "📌"}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-semibold text-[var(--color-foreground)] truncate">{p.title}</span>
                  {p.revenueImpactCents > 0 && (
                    <span className="text-xs font-medium text-[var(--color-success)] ml-2 flex-shrink-0">
                      {new Intl.NumberFormat("en", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(p.revenueImpactCents / 100)}
                    </span>
                  )}
                </div>
                <div className="text-xs text-[var(--color-muted-foreground)] mt-0.5">{p.description}</div>
                <div className="text-xs text-[var(--color-primary)] font-medium mt-1">{p.suggestedAction}</div>
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
